export const CONNECTION = {
  connection: "se-bigquery",
  project: `cartodb-gcp-solutions-eng-team`,
  dataset: "WTW",
  table: "visitors_table_london",
  table_raw: "lifesight_london",
  origin_destination: "origins_destinations_matrix",
  table_wide: "visitors_table",
  table_wide_raw: "lifesight",
  travelled_countries: "travelled_countries",
  brands_visited: "brands_visited",
  geobehaviour: "geobehaviour",
};

export const VISUALS = {
  buckets: 7,
  buckets_origins: 2,
  attr: "n_visitors",
  primary_palette: "PinkYl",
  secondary_palette: "SunsetDark",
};
